import React from 'react'

import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { cn } from '@/lib/utils.ts'

export interface CancelledStatusProps extends React.HtmlHTMLAttributes<HTMLDivElement> {}

export const CancelledStatus = React.forwardRef<HTMLDivElement, CancelledStatusProps>(
  ({ className, ...props }, ref) => (
    <div className="relative flex size-8 items-center justify-center">
      <Icons.x className="z-10 stroke-red-800" />
      <Icons.circle
        className={cn('absolute top-0 left-0 fill-red-500 stroke-red-800', className)}
        ref={ref}
        {...props}
      />
    </div>
  )
)
